module.exports = __webpack_public_path__ + "img/hexalud_logo.ad146948.png";